export default __webpack_public_path__ + "static/media/img-automechanic.3178e2ba.png";